export const FEEDBACK_CONSTANTS = {
    DEFAULT_FILE_NAME: 'proctor_feedback.xlsx',
    DEFAULT_MIME_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}